import { AppThunkDispatch } from '@Reducers/index';

import { CompanyApi } from '@ClientApi/company';
import { IAccountingConnectionModel, ICompanyModel, ICompanyPolicyModel } from '@Shared/models';

export const STORE_COMPANY = 'STORE_COMPANY';
export const STORE_COMPANY_POLICY = 'STORE_COMPANY_POLICY';
export const STORE_COMPANY_ACCOUNTING_INTEGRATION = 'STORE_COMPANY_ACCOUNTING_INTEGRATION';
export const SET_LOADING_ACCOUNTING_INTEGRATION = 'SET_LOADING_ACCOUNTING_INTEGRATION';

export class StoreCompany {
  readonly type = STORE_COMPANY;

  constructor(public company: ICompanyModel) {}
}
export class SetLoadingAccountingIntegration {
  readonly type = SET_LOADING_ACCOUNTING_INTEGRATION;

  constructor(public loading: boolean) {}
}

export const getCompanyWithAccountingIntegration = () => async (dispatch: AppThunkDispatch) => {
  dispatch(new SetLoadingAccountingIntegration(true));
  try {
    const company = await CompanyApi.get(['accounting_integration']);
    dispatch(new StoreCompany(company));
  } finally {
    dispatch(new SetLoadingAccountingIntegration(false));
  }
};

export const getCompanyWithCustomOnBoardingChecklist = () => async (dispatch: AppThunkDispatch) => {
  const company = await CompanyApi.get(['custom_onboarding_checklist']);
  dispatch(new StoreCompany(company));
};

export class StoreCompanyPolicy {
  readonly type = STORE_COMPANY_POLICY;

  constructor(public companyPolicy: ICompanyPolicyModel) {}
}

export class StoreCompanyAccountingIntegration {
  readonly type = STORE_COMPANY_ACCOUNTING_INTEGRATION;

  constructor(public accountingIntegration: IAccountingConnectionModel) {}
}

export type CompanyAction = StoreCompany | StoreCompanyPolicy | StoreCompanyAccountingIntegration | SetLoadingAccountingIntegration;
